import { SegmentedControl } from "@helmr/ui";
import { useLocation, useNavigate } from "react-router-dom";
import { fu } from "./strings";

type Tab = "followups" | "appointments" | "tasks";
const PATH: Record<Tab, string> = { followups: "/followups", appointments: "/followups/appointments", tasks: "/followups/tasks" };

/** The three work lists share one switcher; each is its own route so Home's "View all" links land on the right one. */
export function WorkNav() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const value: Tab = pathname.startsWith(PATH.appointments) ? "appointments" : pathname.startsWith(PATH.tasks) ? "tasks" : "followups";
  return (
    <SegmentedControl
      label={fu.tabs.label}
      value={value}
      onChange={(v) => nav(PATH[v])}
      options={[{ value: "followups", label: fu.tabs.followups }, { value: "appointments", label: fu.tabs.appointments }, { value: "tasks", label: fu.tabs.tasks }]}
    />
  );
}
